var _path, _g, _path2, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapSearch = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9741_2440",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 1.33325H14.3179V14.3179H1.33337V1.33325Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9741_2440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8258 2.33325C4.79713 2.33325 2.33313 4.79659 2.33313 7.82525C2.33313 10.8539 4.79713 13.3179 7.8258 13.3179C10.8538 13.3179 13.3178 10.8539 13.3178 7.82525C13.3178 4.79659 10.8538 2.33325 7.8258 2.33325ZM7.8258 14.3179C4.2458 14.3179 1.33313 11.4053 1.33313 7.82525C1.33313 4.24525 4.2458 1.33325 7.8258 1.33325C11.4058 1.33325 14.3178 4.24525 14.3178 7.82525C14.3178 11.4053 11.4058 14.3179 7.8258 14.3179Z",
    fill: "#9B9FB8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9741_2440",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 4,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4933 11.8044H14.8427V15.1476H11.4933V11.8044Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9741_2440)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3428 15.1476C14.2155 15.1476 14.0875 15.0989 13.9895 15.0016L11.6401 12.6589C11.4448 12.4636 11.4441 12.1469 11.6395 11.9516C11.8341 11.7549 12.1508 11.7563 12.3468 11.9503L14.6961 14.2936C14.8915 14.4889 14.8921 14.8049 14.6968 15.0003C14.5995 15.0989 14.4708 15.1476 14.3428 15.1476Z",
    fill: "#9B9FB8"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-search.feaf0d63.svg";
export { ForwardRef as ReactComponent };